import React from 'react'
import { withRouter } from 'react-router-dom'

class ScrollToTop extends React.Component {
  componentWillReceiveProps(props) {
    if (this.props.location !== props.location) {
      this.doScroll = true
    }
  }

  componentDidUpdate() {
    if (this.doScroll) {
      window.scrollTo(0, 0)
      this.doScroll = false
    }
  }

  render() {
    return this.props.children || null
  }
}

export default withRouter(ScrollToTop)



// WEBPACK FOOTER //
// ./src/components/ScrollToTop.js